import { graphql } from '../../graphql/graphql';

export const saveRecentlyViewedPropertyMutation = graphql(`
  mutation saveRecentlyViewedProperty($propertyId: String!) {
    saveRecentlyViewedProperty(propertyId: $propertyId) {
      recentlyViewedProperties {
        id
      }
    }
  }
`);
